import React from 'react'
import { Icon, Popup } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export const BackToStatisticsButton: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Popup
      content={t('global.back')}
      trigger={
        <Link to='/stats'>
          <Icon link name='arrow left' size='large' color='black' />
        </Link>
      }
    />
  )
}
